// extracted by mini-css-extract-plugin
export var closeButton = "_pe-2";
export var closeButtonIcon = "_pe-3";
export var lightboxContent = "_pe-1";
export var lightboxOverlay = "_pe-0";